<template>
    <flex-element :element-type="elementType" class="f-overflow-hidden">
        <!-- drawer header: -->
        <o-container
            class="f-py-0.75 f-pr-0.5 f-flex f-items-center f-justify-between f-cursor-pointer"
            v-bind="element(1)"
            @click.native="drawerOnClick"
            @element-updated="elementUpdated"
        >
            <template v-slot="{ element, elementUpdated }">
                <a-text-single-line v-bind="element(1)" @element-updated="elementUpdated" />

                <o-container v-bind="element(2)" @element-updated="elementUpdated">
                    <a-icon v-if="isIconVisible" :icon="iconDefaultImg" />
                </o-container>
            </template>
        </o-container>

        <!-- drawer body: -->
        <div class="collapsible__body" :style="drawerBodyStyleObj">
            <div ref="collapsibleBody">
                <drop-zone-single v-bind="element(2)" @element-updated="elementUpdated" />
            </div>
        </div>
    </flex-element>
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-dumb';

const ANIMATION_SPEED = 0.3; // in seconds

export default {
    mixins: [baseOrganism],

    props: {
        iconCollapsed: {
            type: String,
            required: true,
        },

        iconExpanded: {
            type: String,
            required: true,
        },

        expandedDrawerIndex: {
            type: Number,
            required: true,
        },

        closeOtherDrawers: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            isDrawerBodyVisible: false,
            height: 0,
            iconImgCollapsed: '',
            iconImgExpanded: '',
        };
    },

    computed: {
        drawerBodyStyleObj() {
            let styleObj;

            if (this.isDrawerBodyVisible) {
                styleObj = {
                    transition: `${ ANIMATION_SPEED }s all ease`,
                    height: this.height,
                    opacity: 1,
                };
            } else {
                styleObj = {
                    transition: `${ ANIMATION_SPEED }s all ease`,
                    height: this.height,
                    pointerEvents: 'none',
                    padding: 0,
                    opacity: 0,
                    transform: 'translateY(-20px)',
                };
            }

            return styleObj;
        },

        iconDefaultImg() {
            return this.isDrawerBodyVisible ? this.iconExpanded : this.iconCollapsed;
        },

        isIconVisible() {
            // only show the icon if one has been chosen for the current collapsed/expanded state
            return (this.isDrawerBodyVisible && !!this.iconExpanded) || (!this.isDrawerBodyVisible && !!this.iconCollapsed);
        },
    },

    watch: {
        expandedDrawerIndex(drawerIndex) {
            if (drawerIndex !== this.index && this.closeOtherDrawers) {
                this.isDrawerBodyVisible = false;
                this.height = 0;
            }
        },
    },

    methods: {
        drawerOnClick() {
            this.isDrawerBodyVisible = !this.isDrawerBodyVisible;

            const contentHeight = this.$refs.collapsibleBody.offsetHeight;

            if (!this.isDrawerBodyVisible) {
                this.height = 0;
            } else {
                this.height = `${ contentHeight }px`;
            }

            if (this.isDrawerBodyVisible) {
                this.$emit('expanded', this.index);
            }
        },
    },
};
</script>
